/**
 * @generated SignedSource<<4b7b349c130a48aa1536b2a70c01bedc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useUserCouponMutationsRevokeMutation$variables = {
  id: string;
};
export type useUserCouponMutationsRevokeMutation$data = {
  readonly revokeUserCoupon: {
    readonly errors: ReadonlyArray<{
      readonly code: string | null | undefined;
      readonly fields: ReadonlyArray<string> | null | undefined;
      readonly message: string | null | undefined;
      readonly shortMessage: string | null | undefined;
      readonly vars: any | null | undefined;
    }>;
    readonly result: {
      readonly id: string;
      readonly removedOn: any | null | undefined;
    } | null | undefined;
  };
};
export type useUserCouponMutationsRevokeMutation = {
  response: useUserCouponMutationsRevokeMutation$data;
  variables: useUserCouponMutationsRevokeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "RevokeUserCouponResult",
    "kind": "LinkedField",
    "name": "revokeUserCoupon",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserCoupon",
        "kind": "LinkedField",
        "name": "result",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "removedOn",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fields",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shortMessage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vars",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUserCouponMutationsRevokeMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUserCouponMutationsRevokeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c123b9fedf0d573ab5fdd4deed353877",
    "id": null,
    "metadata": {},
    "name": "useUserCouponMutationsRevokeMutation",
    "operationKind": "mutation",
    "text": "mutation useUserCouponMutationsRevokeMutation(\n  $id: ID!\n) {\n  revokeUserCoupon(id: $id) {\n    result {\n      id\n      removedOn\n    }\n    errors {\n      message\n      fields\n      code\n      shortMessage\n      vars\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8bf07598e89e374f491e4a64d179483d";

export default node;
